
import logo from './logo.svg';
import './App.css';
import './components/header.css';
import './components/language.css';
import './components/searching-tutorial.css';
import './components/hypertex.css';
import './components/styling.css';
import './components/scripting.css';
import './components/python-section.css';
import './components/query.css';
import './components/language-boxes.css';
import './components/login.css';
import './components/code-editor.css';
import './components/spaces.css';
import './components/features.css';
import './components/teacher-section.css';
import './components/colorpick.css';
import './components/game.css';
import './components/quiz.css';
import './components/tempelate.css';
import './components/certified.css';
import './components/learn.css';
import 'slick-carousel/slick/slick.css';
import Slider from 'react-slick';


import Header from './components/header';
import Footer from './components/footer';
import Lanuage from './components/lanuage';
import SearchingTutorial from './components/searching-tutorial';
import Hypertext from './components/hypertex';
import Styling from './components/styling';
import Scripting from './components/scripting';
import Python from './components/python-section';
import Query from './components/query';
import LanguageBoxes from './components/language-boxes';
import Login from './components/login';
import Editor from './components/code-editor';
import Spaces from './components/spaces';
import Features from './components/features';
import TeacherSection  from './components/teacher-section';
import Picker from './components/colorpick';
import Game from './components/game';
import Quiz from './components/quiz';
import Tempelate from './components/tempelate';
import Certified from './components/certified';
import LearningSection from './components/learn';
import Carousel from './components/addCourasel';


function App() {
  return (
    <>
    <Header/>
   <Lanuage/>
   <SearchingTutorial/>
   <Hypertext/>
  <Styling/>
<Scripting/>
<Python/>
<Query/>
<LanguageBoxes/>
<Login/>
<Editor/>
<Spaces/>
<Features/>
<TeacherSection/>
<Picker/>
<Game/>
<Quiz/>
<Tempelate/>
<Certified/>
<LearningSection/>
<Footer/>
  </>

  );
}

export default App;
